module.exports = __webpack_public_path__ + "static/img/solutionConceptPic3.a5ff2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionConceptPic3.jpg
// module id = 5Y+t
// module chunks = 0